




































import { Vue, Component } from 'vue-property-decorator';
import { Toast, List, Loading } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { getNewsList } from '../api';
import NewsItem from '../components/NewsItem.vue';
import { getChannelList } from '../api/util';
import qs from 'qs';
Vue.use(Loading)
  .use(List)
  .use(Toast);
@Component({
  components: {
    NewsItem,
    List,
  },
})
export default class Home extends Vue {
  currentArch: string = '';
  newsList: any[] = [];
  loading: boolean = false;
  finished: boolean = false;
  isShowList: boolean = true;
  tabs: any[] = [];
  page: number = 1;
  pageSize: number = 6;
  async created() {
    this.tabs = getChannelList();
    const id = this.$route.query.id as string;
    if (!id) {
      this.currentArch = this.tabs[0].id;
    } else {
      this.currentArch = id;
    }
    // this.loadData();
    setTimeout(() => {
      // const navBar = this.$refs.navBar as HTMLDivElement;
      const target = (document.querySelector(
        `div[arch="${this.currentArch}"]`,
      ) as HTMLDivElement).offsetLeft;
      // console.log(navBar, target)
      (this.$refs.navBar as HTMLDivElement).scrollTo({
        left: target,
        behavior: 'smooth',
      });
    }, 500);
  }
  loadData() {
    return getNewsList({
      page: this.page,
      classId: this.currentArch,
    })
      .then((res: any) => {
        if (res.statusCode !== 200) {
          Toast(res.message);
          return;
        }
        const list =
          res.data &&
          res.data.data instanceof Array &&
          res.data.data.length > 0 &&
          res.data.data[0].list instanceof Array
            ? res.data.data[0].list
            : [];
        this.newsList = [...this.newsList, ...list];
        this.finished = list.length < this.pageSize; // 加载完成
        if (!this.finished) {
          this.page++;
        }
      })
      .catch(() => {
        Toast('网络错误');
        this.loading = false;
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  setNav(item: number) {
    if (this.currentArch === item + '') {
      return false;
    }
    this.isShowList = false;
    this.currentArch = item + '';
    this.newsList = [];
    this.finished = false;
    this.loading = false;
    this.page = 1;
    setTimeout(() => {
      this.isShowList = true;
    }, 50);
    // this.loadData();
    // this.$router.push(`${this.$route.path}?id=${this.currentArch}`);
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
